import React, { CSSProperties, useMemo } from 'react';

interface BootstrapAvatarProps {
  name: string;
  size?: number | string;
  color?: string;
  className?: string;
  round?: boolean;
  textColor?: string;
  imageUrl?: string;
}

const BootstrapAvatar: React.FC<BootstrapAvatarProps> = ({
  name,
  size = 40,
  color = '#707089',
  textColor = '#FFF',
  className = '',
  round = false,
  imageUrl,
}) => {
  const initials = useMemo(() => {
    if (!name.trim()) {
      return '?';
    }
    const parts: string[] = name.trim().split(/\s+/);
    const letters: string[] = parts.slice(0, 2).map((n) => n.charAt(0).toUpperCase());
    return letters.join('');
  }, [name]);

  const sizeValue: string = typeof size === 'number' ? `${size}px` : size;

  const style: CSSProperties = {
    width: sizeValue,
    height: sizeValue,
    backgroundColor: color,
    color: textColor,
    userSelect: 'none',
    overflow: 'hidden',
    objectFit: 'cover',
    fontSize: `calc(${typeof size === 'number' ? size / 2.5 : '1rem'}`
  };

  const borderClass: string = round ? 'rounded-circle' : 'rounded';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        title={name}
        className={`d-inline-block ${borderClass} ${className}`}
        style={style}
      />
    );
  }

  return (
    <div
      className={`d-inline-flex align-items-center justify-content-center fw-bold ${borderClass} ${className}`}
      style={style}
      title={name}
    >
      {initials}
    </div>
  );
};

export default BootstrapAvatar;
